import { Component, Input, OnInit } from '@angular/core';
import {
  OdbCoverDetailDivisionType,
  coverService,
} from '@dch/billing-business-logic';
import { TranslationService } from '@dch/ng-common';

@Component({
  selector: 'my-bill-odb-division-identifier',
  templateUrl: './odb-division-identifier.component.html',
  standalone: false,
})
export class OdbDivisionIdentifierComponent implements OnInit {
  @Input() identifier?: string;
  @Input() type: OdbCoverDetailDivisionType;
  @Input() hasDivisionIdentifierAtFirstPosition: boolean;

  label: string;

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    this.label = coverService.getDivisionIdentifierLabel(
      this.type,
      (key) => this.translationService.getTranslatedValueFor(key),
      this.identifier
    );
  }
}
